module.exports = __webpack_public_path__ + "img/a3.51c7b42a.jpg";